export default "__VITE_ASSET__DV8Xw0tZ__"